import DraftNotSubmitted from 'src/assets/images/DraftNotSubmitted.svg';
import BillingIssues from 'src/assets/images/BillingIssues.svg';
import FullyInvoiced from 'src/assets/images/FullyInvoiced.svg';
import InProcess from 'src/assets/images/InProcess.svg';
import PartiallyShipped from 'src/assets/images/PartiallyShipped.svg';
import PaymentInformationNeeded from 'src/assets/images/PaymentInformationNeeded.svg';
import CreditIssued from 'src/assets/images/CreditIssued.svg';
import ShippedComplete from 'src/assets/images/ShippedComplete.svg';
import SubmittedPendingPriceOverride from 'src/assets/images/SubmittedPendingPriceOverride.svg';
import UsageCompleted from 'src/assets/images/UsageCompleted.svg';
import UsagePending from 'src/assets/images/UsagePending.svg';
import UsageSubmittedPendingInvoice from 'src/assets/images/UsageSubmittedPendingInvoice.svg';
import NonUse from 'src/assets/images/NonUse.svg';
import Cancelled from 'src/assets/images/Cancelled.svg';
import CompletedStatus from 'src/assets/images/CompletedStatus.svg';
import AwaitingReturnStatus from 'src/assets/images/AwaitingReturnStatus.svg';
import BillingSubmittedPendingInvoice from 'src/assets/images/BillingSubmittedPendingInvoice.svg';
import DeliveryBlock from 'src/assets/images/DeliveryBlock.svg';
import PartialReturn from 'src/assets/images/PartialReturn.svg';
import PendingInvoice from 'src/assets/images/PendingInvoice.svg';
import BillingBlock from 'src/assets/images/BillingBlock.svg';
import PendingPriceOverrideApproval from 'src/assets/images/PendingPriceOverrideApproval.svg';
import i18n from 'src/i18n.js';
const t = (key) => i18n.t(key);

export const FILTER_DROPDOWN_HEADERS = [
    {
        filterHeaderId: 1,
        value: 'filter.calendarView',
    },
    {
        filterHeaderId: 2,
        value: 'filter.filterByOrderStatus',
    },
    {
        filterHeaderId: 3,
        value: 'filter.filterByPhysician',
    },
    {
        filterHeaderId: 4,
        value: 'filter.filterByAccount',
    },
    {
        filterHeaderId: 5,
        value: 'filter.filterByProcedure',
    },
    {
        filterHeaderId: 6,
        value: 'filter.filterByOrderType',
    },
];

export const ORDER_STATUS_GROUPS = () => ({
    allObj: [
        {
            description: t('orders.orderDetails.shipAndTrack.all'),
            // description: 'All',
            isChecked: false,
            statusCode: 'All',
        },
    ],
    needsAction: [
        {
            description: t('orders.orderStatuses.draftNotSubmitted'),
            // description: 'Draft Not Submitted',
            filterIconUrl: DraftNotSubmitted,
        },
        {
            description: t('orders.orderStatuses.usagePending'),
            // description: 'Usage Pending',
            filterIconUrl: UsagePending,
        },
        {
            description: t('orders.orderStatuses.paymentInformationNeeded'),
            // description: 'Awaiting PO',
            filterIconUrl: PaymentInformationNeeded,
        },
        {
            description: t(
                'orders.orderStatuses.submittedPendingPriceOverride'
            ),
            // description: 'Submitted Pending Price Override',
            filterIconUrl: SubmittedPendingPriceOverride,
        },
        {
            description: t('orders.orderStatuses.usageCompleted'),
            // description: 'Usage Completed',
            filterIconUrl: UsageCompleted,
        },
    ],
    information: [
        {
            description: t('orders.orderStatuses.inProcess'),
            // description: 'In Process',
            filterIconUrl: InProcess,
        },
        {
            description: t('orders.orderStatuses.partialShipped'),
            // description: 'Partial Shipped',
            filterIconUrl: PartiallyShipped,
        },
        {
            description: t('orders.orderStatuses.shippedComplete'),
            // description: 'Shipped Complete',
            filterIconUrl: ShippedComplete,
        },
        {
            description: t('orders.orderStatuses.usageSubmittedPendingInvoice'),
            // description: 'Usage Submitted Pending Invoice',
            filterIconUrl: UsageSubmittedPendingInvoice,
        },
        {
            description: t('orders.orderStatuses.billingIssues'),
            // description: 'Billing Issues',
            filterIconUrl: BillingIssues,
        },
        {
            description: t('orders.orderStatuses.fullyInvoiced'),
            // description: 'Fully Invoiced',
            filterIconUrl: FullyInvoiced,
        },
    ],
});

export const SCHEDULE_SURGERY_FILTER_DROPDOWN = () => [
    {
        filterHeaderId: 1,
        value: t('orders.orderListViewFilterDropDown.account'),
    },
    {
        filterHeaderId: 2,
        value: t('templates.templatesFilterDropdown.physician'),
    },
    {
        filterHeaderId: 3,
        value: t('templates.templatesFilterDropdown.procedure'),
    },
    {
        filterHeaderId: 4,
        value: t('templates.templatesFilterDropdown.createdBy'),
    },
];

export const ORDER_LIST_FILTER_DROPDOWN = () => [
    {
        filterHeaderId: 1,
        value: t('orders.orderListFilterDropDown.all.value'),
        categoryName: i18n.t('orders.orderListFilterDropDown.all.categoryName'),
    },
    {
        filterHeaderId: 2,
        value: t('orders.orderListFilterDropDown.orderType.value'),
        categoryName: '',
    },
    {
        filterHeaderId: 3,
        value: t('orders.orderListFilterDropDown.usage.value'),
        categoryName: t('orders.orderListFilterDropDown.usage.categoryName'),
    },
    {
        filterHeaderId: 4,
        value: t('orders.orderListFilterDropDown.surgery.value'),
        categoryName: t('orders.orderListFilterDropDown.surgery.categoryName'),
    },
    {
        filterHeaderId: 5,
        value: t('orders.orderListFilterDropDown.equity.value'),
        categoryName: t('orders.orderListFilterDropDown.equity.categoryName'),
    },
    {
        filterHeaderId: 6,
        value: t('orders.orderListFilterDropDown.creditDebitReturns.value'),
        categoryName: t(
            'orders.orderListFilterDropDown.creditDebitReturns.categoryName'
        ),
    },
    {
        filterHeaderId: 7,
        value: t('orders.orderListFilterDropDown.ConsignmentOrderStatus.value'),
        categoryName: t(
            'orders.orderListFilterDropDown.ConsignmentOrderStatus.categoryName'
        ),
    },
     {
        filterHeaderId: 8,
        value: t('orders.orderListFilterDropDown.notificationFailure.value'),
        categoryName:
            ''
        ,
    },
];

export const ORDER_LIST_VIEW_FILTER_DROPDOWN = () => [
    {
        filterHeaderId: 1,
        value: t('orders.orderListViewFilterDropDown.district'),
        name: 'districtView',
    },
    {
        filterHeaderId: 2,
        value: t('orders.orderListViewFilterDropDown.territory'),
        name: 'territoryView',
    },
    {
        filterHeaderId: 3,
        value: t('orders.orderListViewFilterDropDown.account'),
        name: 'accountView',
    },
    {
        filterHeaderId: 4,
        value: t('orders.orderListViewFilterDropDown.orderCondition'),
        name: 'orderConditionView',
    },
];

export const ORDER_LIST_VIEW_ADMIN_DROPDOWN = () => [
    {
        filterHeaderId: 1,
        value: t('admin.adminFilter.filterByDistrict'),
        name: 'districtView',
    },
    {
        filterHeaderId: 2,
        value: t('admin.adminFilter.filterByTerritory'),
        name: 'territoryView',
    },
    {
        filterHeaderId: 3,
        value: t('admin.adminFilter.filterByRoles'),
        name: 'accountView',
    },
];

export const ORDER_LIST_ORDER_STATUS_ICONS = () => ({
    iconList: [
        {
            description: t('orders.orderStatuses.draftNotSubmitted'),
            filterIconUrl: DraftNotSubmitted,
        },
        {
            description: t('orders.orderStatuses.usagePending'),
            filterIconUrl: UsagePending,
        },
        {
            description: t('orders.orderStatuses.paymentInformationNeeded'),
            filterIconUrl: PaymentInformationNeeded,
        },
        {
            description: t(
                'orders.orderStatuses.submittedPendingPriceOverride'
            ),
            filterIconUrl: SubmittedPendingPriceOverride,
        },
        {
            description: t('orders.orderStatuses.usageCompleted'),
            filterIconUrl: UsageCompleted,
        },
        {
            description: t('orders.orderStatuses.inProcess'),
            filterIconUrl: InProcess,
        },
        {
            description: t('orders.orderStatuses.partialShipped'),
            filterIconUrl: PartiallyShipped,
        },
        {
            description: t('orders.orderStatuses.shippedComplete'),
            filterIconUrl: ShippedComplete,
        },
        {
            description: t('orders.orderStatuses.usageSubmittedPendingInvoice'),
            filterIconUrl: UsageSubmittedPendingInvoice,
        },
        {
            description: t('orders.orderStatuses.billingIssues'),
            filterIconUrl: BillingIssues,
        },
        {
            description: t('orders.orderStatuses.fullyInvoiced'),
            filterIconUrl: FullyInvoiced,
        },
        {
            description: t('orders.orderStatuses.cancelled'),
            filterIconUrl: Cancelled,
        },
        {
            description: t('orders.orderStatuses.all'),
            filterIconUrl: UsageCompleted,
        },
        {
            description: t('orders.orderStatuses.nonUse'),
            filterIconUrl: NonUse,
        },
        {
            description: t('orders.orderStatuses.awaitingReturn'),
            filterIconUrl: AwaitingReturnStatus,
        },
        {
            description: t('orders.orderStatuses.complete'),
            filterIconUrl: CompletedStatus,
        },
        {
            description: t(
                'orders.orderStatuses.billingSubmittedPendingInvoice'
            ),
            filterIconUrl: BillingSubmittedPendingInvoice,
        },
        {
            description: t('orders.orderStatuses.deliveryBlock'),
            filterIconUrl: DeliveryBlock,
        },
        {
            description: t('orders.orderStatuses.partialReturn'),
            filterIconUrl: PartialReturn,
        },
        {
            description: t('orders.orderStatuses.nonUseSubmitted'),
            filterIconUrl: NonUse,
        },
        {
            description: t('orders.orderStatuses.pendingPriceOverrideApproval'),
            filterIconUrl: PendingPriceOverrideApproval,
        },
        {
            description: t('orders.orderStatuses.pendingInvoice'),
            filterIconUrl: PendingInvoice,
        },
        {
            description: t('orders.orderStatuses.billingBlock'),
            filterIconUrl: BillingBlock,
        },
        {
            description: t('orders.orderStatuses.paymentInformationNeeded'),
            filterIconUrl: PaymentInformationNeeded,
        },
        {
            description: t('orders.orderStatuses.creditIssued'),
            filterIconUrl: CreditIssued,
        },
    ],
});

export const ACCOUNT_LIST_VIEW_FILTER_DROPDOWN = () => [
    {
        filterHeaderId: 1,
        value: t('ConsignmentAdd.common.bundleItems.createTemplate.district'),
        name: 'districtView',
    },
    {
        filterHeaderId: 2,
        value: t('ConsignmentAdd.common.bundleItems.createTemplate.territory'),
        name: 'territoryView',
    },
];

export const TEMPLATES_FILTER_DROPDOWN = () => [
    {
        filterHeaderId: 1,
        value: t('templates.templatesFilterDropdown.type'),
    },
    {
        filterHeaderId: 2,
        value: t('templates.templatesFilterDropdown.account'),
    },
    {
        filterHeaderId: 3,
        value: t('templates.templatesFilterDropdown.physician'),
    },
    {
        filterHeaderId: 4,
        value: t('templates.templatesFilterDropdown.procedure'),
    },
    {
        filterHeaderId: 5,
        value: t('templates.templatesFilterDropdown.createdBy'),
    },
];

export const ADMIN_LIST_VIEW_FILTER_DROPDOWN = () => [
    {
        filterHeaderId: 1,
        value: t('admin.adminFilter.filterByDistrict'),
        name: 'districtView',
    },
    {
        filterHeaderId: 2,
        value: t('admin.adminFilter.filterByTerritory'),
        name: 'territoryView',
    },
    {
        filterHeaderId: 3,
        value: t('admin.adminFilter.filterByRoles'),
        name: 'roleView',
    },
];
